import { z } from "zod";
import { CHECKLIST, QUALITY_CHECK } from "./consts";

export const schema = z.object({
  [CHECKLIST]: z.any().optional(),
  [QUALITY_CHECK]: z.array(z.string()).min(1, "This Field is required."),
});

export type formValues = z.infer<typeof schema>;
